import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@9b3kuq5phwuk4txw/kiban-react-ui/primitives'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { z } from 'zod'
import { CreateDealDialog } from './-components/CreateDealDialog'
import { DetailArea } from './-components/DetailArea'
import { ListArea } from './-components/ListArea'
import { SearchArea } from './-components/SearchArea'
import { DEFAULT_INQUIRY_SEARCH } from './-lib/inquiry-search-parser'

const inquiriesSearchSchema = z.object({
  search: z.string().optional().default(DEFAULT_INQUIRY_SEARCH),
  selectedId: z.coerce.number().optional(),
})

export const Route = createFileRoute('/_authenticated/inquiries/')({
  component: InquiriesHomePage,
  validateSearch: inquiriesSearchSchema,
})

function InquiriesHomePage() {
  const [createDealOpen, setCreateDealOpen] = useState(false)

  return (
    <div className='h-full w-full'>
      <CreateDealDialog open={createDealOpen} onOpenChange={setCreateDealOpen} />
      <ResizablePanelGroup orientation='horizontal' className='h-full'>
        <ResizablePanel defaultSize='66%' className='grid grid-rows-[auto_minmax(0,1fr)] min-w-0'>
          <SearchArea />
          <ListArea />
        </ResizablePanel>
        <ResizableHandle withHandle />
        <ResizablePanel>
          <DetailArea />
        </ResizablePanel>
      </ResizablePanelGroup>
    </div>
  )
}
